import {
    DETAILS_OF_FILM_EXHIBITION_PLAN,
    LICENCE_TYPE,
    OPERATING_ADDRESS_INFORMATION,
    SUPPORTING_DOCUMENTS,
    OPERATING_ADDRESS_INFORMATION_TEMPORARY,
    AGE_CHECK_MECHANISM,
    FDEL_ADDITIONAL
} from 'common/application.const/Licence/MyApplication/FDELApplication';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatFDELApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let operatingAddressInformation = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    const data =
        licenceDetails?.operatingAddressInformationExhibition?.length > 0
            ? licenceDetails.operatingAddressInformationExhibition
            : licenceDetails?.operatingAddressInformationDistribution?.length > 0
            ? licenceDetails.operatingAddressInformationDistribution
            : null;

    if (data) {
        operatingAddressInformation = data.map((value: any, i: number) => ({
            no: value?.rowId ?? '-',
            'trading-name': value?.tradingName === 'Different from Company/Organisation name' ?  value?.pleaseSpecifyTradingName : licenceDetails?.company?.companyName ?? '-',
            'number-of-halls-or-rooms': value?.numberOfHallsRooms ?? '-',
            duplicated: value?.IsDuplicatedAddress ?? '-',
            rating: value?.OperatingAddressRating ?? '-',
            'videos-are-stored-at-this-place': value?.videosAreStoredAtThisPlace ?? '-',
            'sharing-of-premise': value?.sharingOfPremise ?? '-',
            'premise-type': value?.premiseType ?? '-',
            'address-format': value?.addressFormat ?? '-',
            'postal-code': value?.address?.postalCode ?? '-',
            'building-name': value?.address?.buildingName ?? '-',
            'blk-house-no': value?.address?.blockNo ?? '-',
            'street-name': value?.address?.streetName ?? '-',
            'floor-level': value?.address?.floor ?? '-',
            unit: value?.address?.unit ?? '-',
            'address-line-one': value?.address?.foreignAddress1 ?? '-',
            'address-line-two': value?.address?.foreignAddress2 ?? '-',
            'address-line-three': value?.address?.foreignAddress3 ?? '-'
        }));
    }

    function getDetailOfFilmExhibitionPlan(licenceDetails: any) {
        if (!licenceDetails) return {};

        if (
            licenceDetails?.licenceApplicationInformation?.licenceCategory === 'Exhibition (Restricted) Licence - 1 Year' ||
            licenceDetails?.licenceApplicationInformation?.licenceCategory === 'Exhibition (Restricted) Licence - 3 Year'
        ) {
            const targetAudience = Array.isArray(licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.targetAudience)
                ? licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.targetAudience.map((item: any) => item.mixedValue).join(', ')
                : '-';
            const entryToTheScreeningIs = Array.isArray(licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.entryToTheScreeningIs)
                ? licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.entryToTheScreeningIs
                      .map((item: any) => item.mixedValue)
                      .join(', ')
                : '-';
            return {
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-purpose-objective`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.purposeObjectiveOfFilmExhibition ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-target-audience`]: targetAudience,
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-film-screening-venue`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years
                        ?.theScreeningAtThisVenueSOperatingAddressAsGivenAboveWillBeHeld ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-drive-in-screening`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.thisIsADriveInScreening ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-entry-to-the-screening`]: entryToTheScreeningIs,
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-if-more-than-one-entry`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.ifMoreThan1OptionIsSelectedPleaseClarifyBriefly ?? '-',

                [`${AGE_CHECK_MECHANISM}-security-id-checks`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.securityIdChecksForMinAgeAtAllEntryPointsToTheScreeningArea?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-venue-is-enclosed-for-screening`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.venueIsEnclosedForScreeningOfAgeRestrictedFilms?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-venue-are-enclosed-for-screening`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.venueSAreEnclosedForScreeningOfAgeRestrictedFilms?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-film-rating-signage`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.filmRatingSignagesAreAtPointOfSaleAndEntrances?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-film-ratings-and-consumer`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.filmRatingsAndConsumerAdvisoryAreOnAllPublicityMaterials?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-restricted-film-ratings-and-consumer`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.filmRatingsAndConsumerAdvisoriesAreOnPublicityMaterials?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-all-films-for-screening-in-schedule`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.allFilmsForScreeningInTheScheduleAreImdaClassified?.[0]
                        ?.mixedValue ?? '-',

                [`${FDEL_ADDITIONAL}-technical-requirements`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.technicalRequirements ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.intendToUseLocalBroadcastTransmissionEquipment ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.intendToUseEquipmentToReceiveLocalBroadcastSignals ?? '-',
                [`${FDEL_ADDITIONAL}-will-need-frequencies`]:
                    licenceDetails?.detailsOfFilmExhibitionPlan1Year3Years?.willNeedToUseRadioFrequencies ?? '-'
            };
        }

        if (
            licenceDetails?.licenceApplicationInformation?.licenceCategory === 'Distribution (Restricted) Licence - 1 Year' ||
            licenceDetails?.licenceApplicationInformation?.licenceCategory === 'Distribution (Restricted) Licence - 3 Year'
        ) {
            const targetAudience = Array.isArray(licenceDetails?.detailsOfFilmDistributionPlan?.targetGroupS)
                ? licenceDetails?.detailsOfFilmDistributionPlan?.targetGroupS.map((item: any) => item.mixedValue).join(', ')
                : '-';
            const entryToTheScreeningIs = Array.isArray(licenceDetails?.detailsOfFilmDistributionPlan?.entryToTheScreeningIs)
                ? licenceDetails?.detailsOfFilmDistributionPlan?.entryToTheScreeningIs.map((item: any) => item.mixedValue).join(', ')
                : '-';
            return {
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-purpose-objective`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.purposeObjectiveOfDistributingFilmsVideos ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-target-audience`]: targetAudience,
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-film-screening-venue`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.theScreeningAtThisVenueSOperatingAddressAsGivenAboveWillBeHeld ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-drive-in-screening`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.thisIsADriveInScreening ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-entry-to-the-screening`]: entryToTheScreeningIs,
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-if-more-than-one-entry`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.ifMoreThan1OptionIsSelectedPleaseClarifyBriefly ?? '-',

                [`${AGE_CHECK_MECHANISM}-publicity-materials`]: licenceDetails?.detailsOfFilmDistributionPlan?.imdaFilmRatingsAreOnPublicityMaterials?.[0]?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-consumer-advice`]: licenceDetails?.detailsOfFilmDistributionPlan?.imdaFilmRatingAndConsumerAdviceAreOnFilmsVideos?.[0]?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-r21-films-videos`]: licenceDetails?.detailsOfFilmDistributionPlan?.noDistributionOfR21FilmsVideos?.[0]?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-id-checks-patrons`]: licenceDetails?.detailsOfFilmDistributionPlan?.idChecksForPatronsMinAgeAtPointOfSale?.[0]?.mixedValue ?? '-',

                [`${FDEL_ADDITIONAL}-technical-requirements`]: licenceDetails?.detailsOfFilmDistributionPlan?.technicalRequirements ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.intendToUseLocalBroadcastTransmissionEquipment ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.intendToUseEquipmentToReceiveLocalBroadcastSignals ?? '-',
                [`${FDEL_ADDITIONAL}-will-need-frequencies`]:
                    licenceDetails?.detailsOfFilmDistributionPlan?.willNeedToUseRadioFrequencies ?? '-'
            };
        }

        if (licenceDetails?.licenceApplicationInformation?.licenceCategory === 'Temporary Exhibition - Up to 30 days') {
            const targetAudience = Array.isArray(licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.targetAudience)
                ? licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.targetAudience.map((item: any) => item.mixedValue).join(', ')
                : '-';
            const entryToTheScreeningIs = Array.isArray(licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.entryToTheScreeningIs)
                ? licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.entryToTheScreeningIs.map((item: any) => item.mixedValue).join(', ')
                : '-';
            return {
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.nameOfEvent ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-number-of-halls-rooms`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.numberOfHallsRooms ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.addressFormat ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-postal-code`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.address?.postalCode ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-building-name`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.address?.buildingName ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-blk-house-no`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.address?.blockNo ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-street-name`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.address?.streetName ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-floor-level`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.address?.floor ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-unit`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.address?.unit ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-line-one`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.nameOfEvent ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-line-two`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.nameOfEvent ?? '-',
                [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-line-three`]:
                    licenceDetails?.operatingAddressInformationTemporaryExhibition?.nameOfEvent ?? '-',

                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-purpose-objective`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.purposeObjectiveOfFilmExhibition ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-target-audience`]: targetAudience,
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-film-screening-venue`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.theScreeningAtThisVenueSOperatingAddressAsGivenAboveWillBeHeld ??
                    '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-drive-in-screening`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.thisIsADriveInScreening ?? '-',
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-entry-to-the-screening`]: entryToTheScreeningIs,
                [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-if-more-than-one-entry`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.ifMoreThan1OptionIsSelectedPleaseClarifyBriefly ?? '-',

                [`${AGE_CHECK_MECHANISM}-security-id-checks`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.securityIdChecksForMinAgeAtAllEntryPointsToTheScreeningArea?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-venue-is-enclosed-for-screening`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.venueIsEnclosedForScreeningOfAgeRestrictedFilms?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-venue-are-enclosed-for-screening`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.venueSAreEnclosedForScreeningOfAgeRestrictedFilms?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-film-rating-signage`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.filmRatingSignagesAreAtPointOfSaleAndEntrances?.[0]?.mixedValue ??
                    '-',
                [`${AGE_CHECK_MECHANISM}-film-ratings-and-consumer`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.filmRatingsAndConsumerAdvisoryAreOnAllPublicityMaterials?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-restricted-film-ratings-and-consumer`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.filmRatingsAndConsumerAdvisoriesAreOnPublicityMaterials?.[0]
                        ?.mixedValue ?? '-',
                [`${AGE_CHECK_MECHANISM}-all-films-for-screening-in-schedule`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.allFilmsForScreeningInTheScheduleAreImdaClassified?.[0]
                        ?.mixedValue ?? '-',

                [`${FDEL_ADDITIONAL}-technical-requirements`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.technicalRequirements ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.intendToUseLocalBroadcastTransmissionEquipment ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.intendToUseEquipmentToReceiveLocalBroadcastSignals ?? '-',
                [`${FDEL_ADDITIONAL}-will-need-frequencies`]:
                    licenceDetails?.detailsOfFilmExhibitionPlanTemporary?.willNeedToUseRadioFrequencies ?? '-'
            };
        }

        return {};
    }

    const detailsOfFilmExhibitionPlan = getDetailOfFilmExhibitionPlan(licenceDetails);

    const filmVideoValues = Array.isArray(licenceDetails?.licenceApplicationInformation?.typeOfFilmVideo)
        ? licenceDetails.licenceApplicationInformation.typeOfFilmVideo
              .map((item: any) => item.mixedValue)
              .join(', ')
        : '-';

    const othersValue =
        Array.isArray(licenceDetails?.licenceApplicationInformation?.typeOfFilmVideo) &&
        licenceDetails?.licenceApplicationInformation?.typeOfFilmVideo.some((item: any) => item.mixedValue === 'Others')
            ? licenceDetails?.licenceApplicationInformation?.ifOthersPleaseSpecify ?? '-'
            : '';

    licence = {
        id: 'film-distribution-exhibition-licence',
        formID: 'film-distribution-exhibition-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication-BCG' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_TYPE}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',
            [`${LICENCE_TYPE}-start-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityFromDate ?? '-',
            [`${LICENCE_TYPE}-expiry-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityToDate ?? '-',
            [`${LICENCE_TYPE}-media-type`]: licenceDetails?.licenceApplicationInformation?.mediaTypeJSON ?? '-',
            [`${LICENCE_TYPE}-type-of-filmvideo`]: filmVideoValues,
            [`${LICENCE_TYPE}-other-please-specify`]: othersValue,

            [`${OPERATING_ADDRESS_INFORMATION}-list`]: operatingAddressInformation ?? [...operatingAddressInformation],

            ...detailsOfFilmExhibitionPlan,

            // [`${FDEL_ADDITIONAL}-technical-requirements`]: licenceDetails?.licenceApplicationInformation?.technicalRequirements ?? '-',
            // [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`]: licenceDetails?.licenceApplicationInformation?.intendToUseLocalBroadcastTransmissionEquipment ?? '-',
            // [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`]: licenceDetails?.licenceApplicationInformation?.intendToUseEquipmentToReceiveLocalBroadcastSignals ?? '-',
            // [`${FDEL_ADDITIONAL}-will-need-frequencies`]: licenceDetails?.licenceApplicationInformation?.willNeedToUseRadioFrequencies ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication-BCG' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.cancellationInformation?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'film-distribution-exhibition-licence',
            formID: 'film-distribution-exhibition-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication-BCG' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_TYPE}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',
                [`${LICENCE_TYPE}-start-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityFromDate ?? '-',
                [`${LICENCE_TYPE}-expiry-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityToDate ?? '-',
                [`${LICENCE_TYPE}-media-type`]: licenceDetails?.licenceApplicationInformation?.mediaTypeJSON ?? '-',
                [`${LICENCE_TYPE}-type-of-filmvideo`]: filmVideoValues,
                [`${LICENCE_TYPE}-other-please-specify`]: othersValue,

                [`${OPERATING_ADDRESS_INFORMATION}-list`]: operatingAddressInformation ?? [...operatingAddressInformation],

                ...detailsOfFilmExhibitionPlan,

                [`${FDEL_ADDITIONAL}-technical-requirements`]: licenceDetails?.licenceApplicationInformation?.technicalRequirements ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`]:
                    licenceDetails?.licenceApplicationInformation?.intendToUseLocalBroadcastTransmissionEquipment ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`]:
                    licenceDetails?.licenceApplicationInformation?.intendToUseEquipmentToReceiveLocalBroadcastSignals ?? '-',
                [`${FDEL_ADDITIONAL}-will-need-frequencies`]:
                    licenceDetails?.licenceApplicationInformation?.willNeedToUseRadioFrequencies ?? '-',

                [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-film-distribution-exhibition-licence',
            formID: 'amend-film-distribution-exhibition-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication-BCG' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_TYPE}-amend-table`]: [...mapped],
                [`${LICENCE_TYPE}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',
                [`${LICENCE_TYPE}-start-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityFromDate ?? '-',
                [`${LICENCE_TYPE}-expiry-date`]: licenceDetails?.LicenceCategoryDetails?.ValidityToDate ?? '-',
                [`${LICENCE_TYPE}-media-type`]: licenceDetails?.licenceApplicationInformation?.mediaTypeJSON ?? '-',
                [`${LICENCE_TYPE}-type-of-filmvideo`]: filmVideoValues,
                [`${LICENCE_TYPE}-other-please-specify`]: othersValue,

                [`${OPERATING_ADDRESS_INFORMATION}-list`]: operatingAddressInformation ?? [...operatingAddressInformation],

                ...detailsOfFilmExhibitionPlan,

                [`${FDEL_ADDITIONAL}-technical-requirements`]: licenceDetails?.licenceApplicationInformation?.technicalRequirements ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`]:
                    licenceDetails?.licenceApplicationInformation?.intendToUseLocalBroadcastTransmissionEquipment ?? '-',
                [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`]:
                    licenceDetails?.licenceApplicationInformation?.intendToUseEquipmentToReceiveLocalBroadcastSignals ?? '-',
                [`${FDEL_ADDITIONAL}-will-need-frequencies`]:
                    licenceDetails?.licenceApplicationInformation?.willNeedToUseRadioFrequencies ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const fdelPayloadApplication = {
    formatFDELApplication
};

export default fdelPayloadApplication;
